export const COLORBAR_RANGE_MODE = {
  INCLUDE: "include",
  EXCLUDE: "exclude",
  DECOLOR: "decolor",
};

export const DEFAULT_COLORBAR_RANGE_MODE = COLORBAR_RANGE_MODE.INCLUDE;

export const COLORBAR_RANGE_MODE_OPTIONS = [
  { value: COLORBAR_RANGE_MODE.INCLUDE, label: "Include all" },
  { value: COLORBAR_RANGE_MODE.EXCLUDE, label: "Exclude outliers" },
  { value: COLORBAR_RANGE_MODE.DECOLOR, label: "Decolor outliers" },
];

export const COLORBAR_GRADIENT = {
  HOURS: "hours",
  OTHER: "other",
  WIND_RISK: "wind-risk",
  DAYLIGHT: "daylight",
  PV: "pv",
  ENERGY: "energy",
  SENSOR_PLACEMENT: "sensor-placement",
  WIND_TURBINE: "wind-turbine",
  SOUND_EMISSION: "sound-emission",
};

export const getColorbarGradientClassName = (gradient) =>
  `colorbar-gradient colorbar-gradient--${gradient}`;
